import Button from 'devextreme-react/button';
import { showErrorMessage } from '../../../../utils/messages';
import { useState } from 'react';
import { useSavePrepForTemplateChecklistForm } from '../api/save-prepForTemplateChecklistForm';

const PrepForTemplateChecklistForm: React.FC<{
    retailOrderID: number, retailOrderNumber: string,
    onClosePopup: () => void,
    onCheckboxChange: (checked: boolean) => void,
    onSubmit?: () => void
}> = ({ retailOrderID, retailOrderNumber, onClosePopup, onCheckboxChange, onSubmit }) => {
    const [allCabinetryCheckBox, setAllCabinetryCheckBox] = useState(false);
    const [allExistingSpecialtyCheckBox, setAllExistingSpecialtyCheckBox] = useState(false);
    const [allItemsCheckBox, setAllItemsCheckBox] = useState(false);
    const [apronFrontCheckBox, setApronFrontCheckBox] = useState(false);
    const [allSurfaceAreasCheckBox, setAllSurfaceAreasCheckBox] = useState(false);
    const [customerSuppliedCheckBox, setCustomerSuppliedCheckBox] = useState(false);
    const [customersResponsibilityCheckBox, setCustomersResponsibilityCheckBox] = useState(false);
    const [decisionMakerCheckBox, setDecisionMakerCheckBox] = useState(false);
    const [introduceYourselfCheckBox, setIntroduceYourselfCheckBox] = useState(false);
    const [lowesSurveyCheckBox, setLowesSurveyCheckBox] = useState(false);
    const [mayISpeakToCheckBox, setMayISpeakToCheckBox] = useState(false);
    const [provide4HourWindowCheckBox, setProvide4HourWindowCheckBox] = useState(false);
    const [scheduleProjectCheckBox, setScheduleProjectCheckBox] = useState(false);
    const [waterfallLegsCheckBox, setWaterfallLegsCheckBox] = useState(false);
    const [discussOptionsCheckBox, setDiscussOptionsCheckBox] = useState(false);
    const [plumbingCheckBox, setPlumbingCheckBox] = useState(false);
    const [plumbingConnectionsCheckBox, setPlumbingConnectionsCheckBox] = useState(false);
    const [plumbingDisconnectCheckBox, setPlumbingDisconnectCheckBox] = useState(false);
    const [plumbingDisconnectInstallerCheckBox, setPlumbingDisconnectInstallerCheckBox] = useState(false);
    const [plumbingDisconnecCustomerCheckBox, setPlumbingDisconnecCustomerCheckBox] = useState(false);
    const [plumbing1120679CheckBox, setPlumbing1120679CheckBox] = useState(false);
    const [plumbing1120669CheckBox, setPlumbing1120669CheckBox] = useState(false);
    const [plumbingReconnectCheckBox, setPlumbingReconnectCheckBox] = useState(false);
    const [plumbingReconnectInstallerCheckBox, setPlumbingReconnectInstallerCheckBox] = useState(false);
    const [plumbingReconnectCustomerCheckBox, setPlumbingReconnectCustomerCheckBox] = useState(false);
    const [granite1120680Checkbox, setGranite1120680Checkbox] = useState(false);
    const [granite1120686Checkbox, setGranite1120686Checkbox] = useState(false);
    const [granite1120685Checkbox, setGranite1120685Checkbox] = useState(false);
    const [granite1120684Checkbox, setGranite1120684Checkbox] = useState(false);
    const [quartz1120670Checkbox, setQuartz1120670Checkbox] = useState(false);
    const [quartz1120676Checkbox, setQuartz1120676Checkbox] = useState(false);
    const [quartz1120675Checkbox, setQuartz1120675Checkbox] = useState(false);
    const [quartz1120674Checkbox, setQuartz1120674Checkbox] = useState(false);
    const [graniteGoldProtectionPlanCheckBox, setGraniteGoldProtectionPlanCheckBox] = useState(false);
    const [granite5YearCheckBox, setGranite5YearCheckBox] = useState(false);
    const [granite10YearCheckBox, setGranite10YearCheckBox] = useState(false);
    const [finishingTouchesCheckbox, setFinishingTouchesCheckbox] = useState(false);
    const [supportBracketsCheckBox, setSupportBracketsCheckBox] = useState(false);
    const [safetyCornersCheckBox, setSafetyCornersCheckBox] = useState(false);
    const [chipMinimizerCheckBox, setChipMinimizerCheckBox] = useState(false);
    const [surveyCheckBox, setSurveyCheckBox] = useState(false);
    const [thankYouCheckBox, setThankYouCheckBox] = useState(false);
    const [noteText, setNoteText] = useState('');

    const handleReset = () => {
        setAllCabinetryCheckBox(false);
        setAllExistingSpecialtyCheckBox(false);
        setAllItemsCheckBox(false);
        setApronFrontCheckBox(false);
        setAllSurfaceAreasCheckBox(false);
        setCustomerSuppliedCheckBox(false);
        setCustomersResponsibilityCheckBox(false);
        setDecisionMakerCheckBox(false);
        setIntroduceYourselfCheckBox(false);
        setLowesSurveyCheckBox(false);
        setMayISpeakToCheckBox(false);
        setProvide4HourWindowCheckBox(false);
        setScheduleProjectCheckBox(false);
        setWaterfallLegsCheckBox(false);
        setGranite1120680Checkbox(false);
        setGranite1120686Checkbox(false);
        setGranite1120685Checkbox(false);
        setGranite1120684Checkbox(false);
        setQuartz1120670Checkbox(false);
        setQuartz1120676Checkbox(false);
        setQuartz1120675Checkbox(false);
        setQuartz1120674Checkbox(false);
        setGraniteGoldProtectionPlanCheckBox(false);
        setGranite5YearCheckBox(false);
        setGranite10YearCheckBox(false);
        setFinishingTouchesCheckbox(false);
        setSupportBracketsCheckBox(false);
        setSafetyCornersCheckBox(false);
        setChipMinimizerCheckBox(false);
        setSurveyCheckBox(false);
        setThankYouCheckBox(false);
        setNoteText('');
        setDiscussOptionsCheckBox(false);
        setPlumbingCheckBox(false);
        setPlumbingConnectionsCheckBox(false);
        setPlumbingDisconnectCheckBox(false);
        setPlumbingDisconnectInstallerCheckBox(false);
        setPlumbingDisconnecCustomerCheckBox(false);
        setPlumbing1120679CheckBox(false);
        setPlumbing1120669CheckBox(false);
        setPlumbingReconnectCheckBox(false);
        setPlumbingReconnectInstallerCheckBox(false);
        setPlumbingReconnectCustomerCheckBox(false);
    };

    const handleNoteText = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setNoteText(event.target.value);
    };

    const savePrepForTemplateChecklist = useSavePrepForTemplateChecklistForm(
        {
            formObject: {
                RetailOrderID: retailOrderID,
                RetailOrderNo: retailOrderNumber,
                AllCabinetryCheckBox: allCabinetryCheckBox,
                AllExistingSpecialtyCheckBox: allExistingSpecialtyCheckBox,
                AllItemsCheckBox: allItemsCheckBox,
                AllSurfaceAreasCheckBox: allSurfaceAreasCheckBox,
                ApronFrontCheckBox: apronFrontCheckBox,
                CustomerSuppliedCheckBox: customerSuppliedCheckBox,
                CustomersResponsibilityCheckBox: customersResponsibilityCheckBox,
                DecisionMakerCheckBox: decisionMakerCheckBox,
                IntroduceYourselfCheckBox: introduceYourselfCheckBox,
                LowesSurveyCheckBox: lowesSurveyCheckBox,
                MayISpeakToCheckBox: mayISpeakToCheckBox,
                Provide4HourWindowCheckBox: provide4HourWindowCheckBox,
                ScheduleProjectCheckBox: scheduleProjectCheckBox,
                WaterfallLegsCheckBox: waterfallLegsCheckBox,
                Granite1120680Checkbox: granite1120680Checkbox,
                Granite1120686Checkbox: granite1120686Checkbox,
                Granite1120685Checkbox: granite1120685Checkbox,
                Granite1120684Checkbox: granite1120684Checkbox,
                Quartz1120670Checkbox: quartz1120670Checkbox,
                Quartz1120676Checkbox: quartz1120676Checkbox,
                Quartz1120675Checkbox: quartz1120675Checkbox,
                Quartz1120674Checkbox: quartz1120674Checkbox,
                GraniteGoldProtectionPlanCheckBox: graniteGoldProtectionPlanCheckBox,
                Granite5YearCheckBox: granite5YearCheckBox,
                Granite10YearCheckBox: granite10YearCheckBox,
                FinishingTouchesCheckbox: finishingTouchesCheckbox,
                SupportBracketsCheckBox: supportBracketsCheckBox,
                SafetyCornersCheckBox: safetyCornersCheckBox,
                ChipMinimizerCheckBox: chipMinimizerCheckBox,
                SurveyCheckBox: surveyCheckBox,
                ThankYouCheckBox: thankYouCheckBox,
                NoteText: noteText,
                DiscussOptionsCheckBox: discussOptionsCheckBox,
                PlumbingCheckBox: plumbingCheckBox,
                PlumbingConnectionsCheckBox: plumbingConnectionsCheckBox,
                PlumbingDisconnectCheckBox: plumbingDisconnectCheckBox,
                PlumbingDisconnectInstallerCheckBox: plumbingDisconnectInstallerCheckBox,
                PlumbingDisconnecCustomerCheckBox: plumbingDisconnecCustomerCheckBox,
                Plumbing1120679CheckBox: plumbing1120679CheckBox,
                Plumbing1120669CheckBox : plumbing1120669CheckBox,
                PlumbingReconnectCheckBox: plumbingReconnectCheckBox,
                PlumbingReconnectInstallerCheckBox: plumbingReconnectInstallerCheckBox,
                PlumbingReconnectCustomerCheckBox: plumbingReconnectCustomerCheckBox
            }
        },
        (result) => {
            onClosePopup();
            onCheckboxChange(true);
            if (onSubmit !== undefined) onSubmit!();
        },
        (error) => showErrorMessage(error)
    );

    return (
        <div>
            <div className='main-header'>
                <h1>Project Manager - Prep for Template Checklist</h1>
            </div>
            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Greeting</span></div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={mayISpeakToCheckBox} onChange={(e) => setMayISpeakToCheckBox(e.target.checked)} />
                        “May I speak to (customer name)”
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={introduceYourselfCheckBox} onChange={(e) => setIntroduceYourselfCheckBox(e.target.checked)} />
                        Introduce yourself, your company – in partnership with Lowe’s, and that you’re calling to
                        schedule their installation appointment for their Lowe’s countertop project.
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>For Countertop Templating</span></div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={scheduleProjectCheckBox} onChange={(e) => setScheduleProjectCheckBox(e.target.checked)} />
                        <b>Schedule project</b>
                    </label>
                    <div className='section-row-section-hint'>
                        » Review the Prep for Template Checklist (use the script below) and that they will receive a
                        copy from Lowe’s on the template appointment confirmation email
                    </div>
                    <div className='section-row-section-hint'>
                        » Mention the length of the template appointment
                    </div>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={lowesSurveyCheckBox} onChange={(e) => setLowesSurveyCheckBox(e.target.checked)} />
                        <b><u>Lowe’s survey perfect score expectation –</u></b> “serves as our report card and only scored on a
                        perfect 10.”
                    </label>
                    <div className='section-row-section-hint-italic'>
                        » "Delivering a 10-star countertop experience is our aim, and we're eager to earn your
                        recommendation through our report card. Your feedback is invaluable in helping us
                        achieve a perfect 10 star review."
                    </div>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={decisionMakerCheckBox} onChange={(e) => setDecisionMakerCheckBox(e.target.checked)} />
                        The decision maker (over the age of 18) must be on site. This person is required to sign off all
                        aspects of the project including design (color), edge, faucet holes, and overhangs.
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={allSurfaceAreasCheckBox} onChange={(e) => setAllSurfaceAreasCheckBox(e.target.checked)} />
                        ALL surface areas MUST be cleared off and sink cabinet(s) emptied to ensure accurate
                        measurements and project scope evaluation can be done.
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={allCabinetryCheckBox} onChange={(e) => setAllCabinetryCheckBox(e.target.checked)} />
                        ALL cabinetry and ALL cabinetry panels, not resting on the countertop, MUST be completely
                        and permanently installed (plumb, level & square) and secured to walls and/or floor prior to the
                        field template appointment.
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={allItemsCheckBox} onChange={(e) => setAllItemsCheckBox(e.target.checked)} />
                        ALL items (sinks, faucets, soap pumps, hot/cold water dispensers, cook tops, etc.) must be
                        at the job site prior to field template appointment date, unless purchased as part of your
                        countertop project.
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={customersResponsibilityCheckBox} onChange={(e) => setCustomersResponsibilityCheckBox(e.target.checked)} />
                        It is the customers responsibility to remove, clean and prep existing sinks, faucets, and
                        appliances for reuse.
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>If Applicable:</span></div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={allExistingSpecialtyCheckBox} onChange={(e) => setAllExistingSpecialtyCheckBox(e.target.checked)} />
                        ALL existing specialty cabinets (appliance garages, tall cabinets, etc.) resting on the countertop
                        surface must be completely removed prior to field template appointment date and/or installed
                        after the installation of the countertops. Mirrors or mirror clips that are installed directly on top of
                        the countertop/backsplash surface must be removed prior to installation to ensure safety for all.
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={apronFrontCheckBox} onChange={(e) => setApronFrontCheckBox(e.target.checked)} />
                        Apron front sinks must be installed in their final position.
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={waterfallLegsCheckBox} onChange={(e) => setWaterfallLegsCheckBox(e.target.checked)} />
                        Waterfall legs require flooring to be fully installed.
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={customerSuppliedCheckBox} onChange={(e) => setCustomerSuppliedCheckBox(e.target.checked)} />
                        Customer Supplied supports need to be fully installed.
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={provide4HourWindowCheckBox} onChange={(e) => setProvide4HourWindowCheckBox(e.target.checked)} />
                        Provide 4-hour window of arrival
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Enhancing Options:</span></div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={discussOptionsCheckBox} onChange={(e) => setDiscussOptionsCheckBox(e.target.checked)} />
                        Discuss countertop project options to enhance the customer’s experience and countertop
                        installation. These options can be quoted on a change order after the template appointment
                        where the customer has the option to approve or request to remove.                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={plumbingCheckBox} onChange={(e) => setPlumbingCheckBox(e.target.checked)} />
                        <b>Plumbing</b>
                    </label>
                    <div className='section-row-section-hint'>
                        <b>For plumbing service offered by CFI through Lowe’s SKUs (Quartz & Granite only):</b>
                    </div>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={plumbingConnectionsCheckBox} onChange={(e) => setPlumbingConnectionsCheckBox(e.target.checked)} />
                        Every countertop installation requires a plumbing disconnect and reconnect, would you like
                        to add these services to your countertop project? We can go ahead and add them so you will
                        receive a quote after the template appointment.
                    </label>
                </div>
                <div className='section-row'>
                    <span className='floatLeft'>
                        <label>
                            <input type="checkbox" checked={plumbingDisconnectCheckBox} onChange={(e) => setPlumbingDisconnectCheckBox(e.target.checked)} />
                            <b>Plumbing Disconnect</b>
                        </label>
                    </span>
                    <span style={{ marginLeft: '15px' }}>
                        <label>
                            <input type="checkbox" checked={plumbingDisconnectInstallerCheckBox} onChange={(e) => setPlumbingDisconnectInstallerCheckBox(e.target.checked)} />
                            <b>Installer*</b>
                        </label>
                    </span>
                    <span style={{ marginLeft: '15px' }}>
                        <label>
                            <input type="checkbox" checked={plumbingDisconnecCustomerCheckBox} onChange={(e) => setPlumbingDisconnecCustomerCheckBox(e.target.checked)} />
                            <b>Customer</b>
                        </label>
                    </span>
                    <div className='section-row-section-hint'>
                        <i>*Select the applicable option below if Installer is selected:</i>
                    </div>
                    <div className='section-row-section-hint'>
                        <span className='floatLeft'>
                            <label>
                                <input type="checkbox" checked={plumbing1120679CheckBox} onChange={(e) => setPlumbing1120679CheckBox(e.target.checked)} />
                                1120679: Granite: Plumbing Disconnect
                            </label>
                        </span>
                        <span className='floatLeft' style={{ marginLeft: '10px' }}>
                            <label>
                                <input type="checkbox" checked={plumbing1120669CheckBox} onChange={(e) => setPlumbing1120669CheckBox(e.target.checked)} />
                                1120669: Quartz: Plumbing Disconnect
                            </label>
                        </span>
                    </div>

                    <div style={{ marginTop: '10px' }}>
                        <span>
                            <label>
                                <input type="checkbox" checked={plumbingReconnectCheckBox} onChange={(e) => setPlumbingReconnectCheckBox(e.target.checked)} />
                                <b>Plumbing Reconnect</b>
                            </label>
                        </span>
                        <span style={{ marginLeft: '10px' }}>
                            <label>
                                <input type="checkbox" checked={plumbingReconnectInstallerCheckBox} onChange={(e) => setPlumbingReconnectInstallerCheckBox(e.target.checked)} />
                                Installer*
                            </label>
                        </span>
                        <span style={{ marginLeft: '10px' }}>
                            <label>
                                <input type="checkbox" checked={plumbingReconnectCustomerCheckBox} onChange={(e) => setPlumbingReconnectCustomerCheckBox(e.target.checked)} />
                                Customer
                            </label>
                        </span>
                    </div>

                    <div className='section-row-section-hint'>
                        <i>*Select the applicable option below if Installer is selected:</i>
                    </div>

                    <div className="section-row-section-hint">
                        <label>
                            <div >
                                <b>GRANITE:</b>
                            </div>
                        </label>
                    </div>
                    <div className="section-row-section-hint">
                        <label>
                            <input type="CheckBox" checked={granite1120680Checkbox} onChange={(e) => setGranite1120680Checkbox(e.target.checked)} />
                            1120680: Granite Plumbing: Plumbing Connection of New Main Faucet & Drains to New Sink
                        </label>
                    </div>
                    <div className="section-row-section-hint">
                        <label >
                            <input type="CheckBox" checked={granite1120686Checkbox} onChange={(e) => setGranite1120686Checkbox(e.target.checked)} />
                            1120686: Granite Plumbing: Connect New Faucet Shutoff Valves (includes hot & cold shutoff valves)
                        </label>
                    </div>
                    <div className="section-row-section-hint">
                        <label >
                            <input type="CheckBox" checked={granite1120685Checkbox} onChange={(e) => setGranite1120685Checkbox(e.target.checked)} />
                            1120685: Granite Plumbing: Install New/Existing Dishwasher & Plumbing Connection
                        </label>
                    </div>

                    <div className="section-row-section-hint">
                        <label >
                            <input type="CheckBox" checked={granite1120684Checkbox} onChange={(e) => setGranite1120684Checkbox(e.target.checked)} />
                            1120684: Granite Plumbing: Install New/Existing Garbage Disposal & Plumbing Connection
                        </label>
                    </div>

                    <div className="section-row-section-hint">
                        <label>
                            <div  >
                                <b>QUARTZ:</b>
                            </div>
                        </label>
                    </div>

                    <div className="section-row-section-hint">
                        <label>
                            <input type="CheckBox" checked={quartz1120670Checkbox} onChange={(e) => setQuartz1120670Checkbox(e.target.checked)} />
                            1120670: Quartz Plumbing: Plumbing Connection of New Main Faucet & Drains to New Sink
                        </label>
                    </div>

                    <div className="section-row-section-hint">
                        <label>
                            <input type="CheckBox" checked={quartz1120676Checkbox} onChange={(e) => setQuartz1120676Checkbox(e.target.checked)} />
                            1120676: Quartz Plumbing: Connect New Faucet Shutoff Valves (includes hot & cold shutoff valves)
                        </label>
                    </div>
                    <div className="section-row-section-hint">
                        <label>
                            <input type="CheckBox" checked={quartz1120675Checkbox} onChange={(e) => setQuartz1120675Checkbox(e.target.checked)} />
                            1120675: Quartz Plumbing: Install New/Existing Dishwasher & Plumbing Connection
                        </label>
                    </div>
                    <div className="section-row-section-hint">
                        <label>
                            <input type="CheckBox" checked={quartz1120674Checkbox} onChange={(e) => setQuartz1120674Checkbox(e.target.checked)} />
                            1120674: Quartz Plumbing: Install New/Existing Garbage Disposal & Plumbing Connection
                        </label>
                    </div>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox" checked={graniteGoldProtectionPlanCheckBox} onChange={(e) => setGraniteGoldProtectionPlanCheckBox(e.target.checked)} />
                        <b>Granite Gold Protection Plan</b>
                    </label>

                    <div className="section-row-section-hint">
                        <label>
                            Peace of Mind Protection Accidental Plan that covers chips, etches, household stains, seams,
                            hardwater marks, scratches, and caulking which are items not covered on any included
                            material or installation warranties. Offer to send more information
                        </label>
                    </div>

                    <div className="section-row-section-hint">
                        <span className='floatLeft' style={{ marginLeft: '15px' }}>
                            <label>
                                <input type="CheckBox" checked={granite5YearCheckBox} onChange={(e) => setGranite5YearCheckBox(e.target.checked)} />
                                5 year - $299 retail
                            </label>
                        </span>

                        <span className='floatLeft' style={{ marginLeft: '15px' }}>
                            <label>
                                <input type="CheckBox" checked={granite10YearCheckBox} onChange={(e) => setGranite10YearCheckBox(e.target.checked)} />
                                10 year - $399 retail
                            </label>
                        </span>
                    </div>
                </div>

                <div className='section-row'>
                    <span className='floatLeft'>
                        <label>
                            <input type="CheckBox" checked={finishingTouchesCheckbox} onChange={(e) => setFinishingTouchesCheckbox(e.target.checked)} />
                            <b>Finishing Touches</b>
                        </label>
                    </span>

                    <div className="section-row-section-hint">
                        <span className='floatLeft' >
                            <label>
                                <input type="CheckBox" checked={chipMinimizerCheckBox} onChange={(e) => setChipMinimizerCheckBox(e.target.checked)} />
                                Chip Minimizer
                            </label>
                        </span>
                        <span className='floatLeft' style={{ marginLeft: '15px' }}>
                            <label>
                                <input type="CheckBox" checked={supportBracketsCheckBox} onChange={(e) => setSupportBracketsCheckBox(e.target.checked)} />
                                Support Brackets (if applicable)
                            </label>
                        </span>
                        <span className='floatLeft' style={{ marginLeft: '15px' }}>
                            <label>
                                <input type="CheckBox" checked={safetyCornersCheckBox} onChange={(e) => setSafetyCornersCheckBox(e.target.checked)} />
                                Safety Corners
                            </label>
                        </span>
                    </div>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Closing:</span></div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={surveyCheckBox} onChange={(e) => setSurveyCheckBox(e.target.checked)} />
                        <b>Lowe’s survey perfect score expectation</b> – “serves as our <b><u>report card</u></b> and only scored on aperfect 10.”
                    </label>
                    <div className='section-row-section-hint-italic'>
                        » "Delivering a 10-star countertop experience is our aim, and we’re eager to earn your
                        recommendation through our report card. Your feedback is invaluable in helping us achieve
                        a perfect 10 star review. We always strive for excellence, so if there’s any reason why we
                        haven’t met your expectations on your countertop project, please contact me directly."
                    </div>
                </div>

                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={thankYouCheckBox} onChange={(e) => setThankYouCheckBox(e.target.checked)} />
                        Thank customer, provide contact information
                    </label>
                </div>

                <div className='section-row'>
                    Notes:
                    <textarea
                        className='input-fullsize-large-height'
                        value={noteText}
                        onChange={handleNoteText}
                        placeholder="Note"
                        rows={5}
                        cols={40}
                    />
                </div>
            </div>

            <div className='button-container'>
                <Button
                    text="Reset"
                    className='reset-button'
                    type="danger"
                    onClick={(e) => {
                        handleReset()
                    }} >
                </Button>

                <Button
                    text="Save Changes"
                    className="save-button"
                    onClick={(e) => {
                        savePrepForTemplateChecklist.mutate();
                    }} >
                </Button>
            </div>
        </div >
    );
};

export default PrepForTemplateChecklistForm;
